var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.25,
    height: 14,
    viewBox: "0 0 12.25 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15761",
    "data-name": "Path 15761",
    d: "M7.328-.875h.656A.328.328,0,0,0,8.312-1.2V-7.109a.328.328,0,0,0-.328-.328H7.328A.328.328,0,0,0,7-7.109V-1.2A.328.328,0,0,0,7.328-.875Zm4.484-9.187H9.559l-.93-1.55A1.455,1.455,0,0,0,7.5-12.25H4.747a1.455,1.455,0,0,0-1.125.637l-.93,1.55H.437A.438.438,0,0,0,0-9.625v.437a.438.438,0,0,0,.437.437H.875V.437A1.313,1.313,0,0,0,2.187,1.75h7.875A1.313,1.313,0,0,0,11.375.437V-8.75h.437a.438.438,0,0,0,.437-.437v-.437A.438.438,0,0,0,11.812-10.062Zm-7.114-.8a.182.182,0,0,1,.141-.08H7.41a.182.182,0,0,1,.141.08l.477.8H4.222ZM10.062.437H2.187V-8.75h7.875ZM4.266-.875h.656A.328.328,0,0,0,5.25-1.2V-7.109a.328.328,0,0,0-.328-.328H4.266a.328.328,0,0,0-.328.328V-1.2A.328.328,0,0,0,4.266-.875Z",
    transform: "translate(0 12.25)",
    fill: "#d90327"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.e908e76a79e75c9340cbea8dcd2d516d.svg";
export { ForwardRef as ReactComponent };